export const getReportsList = state => state.reports.reportsList;
export const getIsReportsListOpen = state => state.reports.reportsListIsOpen;
export const getIsReportsListLoading = state => state.reports.reportsListFetchStatus.loading;
export const getHasReportsListFetchFailed = state => state.reports.reportsListFetchStatus.error;
export const getReportsListFetchRetriesCount = state => state.reports.reportsListFetchStatus.retryCount;
export const getReportsListLastFetchTimestamp = state => state.reports.reportsListFetchStatus.lastTimeStamp;



// WEBPACK FOOTER //
// ./app/web/src/selectors/reportsSelectors.js